import { EditGridColumnType } from "../../../components/finalMolGrid/libs/data/editGridColumnType";
import { GridColumnType } from "../../../data/gridColumnType";

export const TodoDocumentsGridConfig = {
  isRowSelectable: true,

  columns: [
    {
      name: "Document",
      fieldName: "sDocumentName",
      allowEditColumn: true,
      allowShort: false,
      editColumn: {
        editColType: EditGridColumnType.INPUT,
        placeholder: "Please Enter Document Name",
        editColFieldName: "sDocumentName",
        isDisable: false,
        colConfig: {
          isReadOnly: false,
          allowSpace: true,
        },
        editColValidation: [
          { type: "required", message: "Document Name is required." },
        ],
      }
    },
    {
      name: "Date Uploaded",
      fieldName: "dtDocumentUploadDate",
      colType: GridColumnType.DATE,
      colSettings: {
        format: "MM/DD/YYYY"
      },
      allowShort: false
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
      customAction: [
        {
          name: "VIEW",
          iconClass: 'carbon:document',
        },
      ],
      allowShort: false
    },
  ],
  editSettings: {
    buttons: {
      save: true,
      cancel: true
    }
  },
  allowEdit: true,
  handleRowDataUpdate: null,
  OnColumnChangeEdit: null,
  hasChildGridTable: false,
};
